"use client";

import React, { FC, PropsWithChildren, useEffect } from "react";
import {
  GlobalStateProvider,
  IToolboxComponentGroup,
  ShaApplicationProvider,
  StoredFilesProvider,
  useNextRouter,
  useSheshaApplication,
} from "@shesha-io/reactjs";
import {
  GlobalPublicPortalStyles,
  PublicPortalApplicationPlugin,
} from "@shesha-io/pd-publicportal";
import { EnterpriseApplicationPlugin } from "@shesha-io/enterprise";
import { InvoiceLineItemsComponent } from "@/components/invoiceLineItems";
import {
  SupplierContextProvider,
  buildSupplierHeaders,
} from "@/components/supplierContext";

const SUPPLIER_PORTAL_PLUGIN_NAME = "supplier-portal";

const supplierPortalDesignerComponents: IToolboxComponentGroup[] = [
  {
    name: "Supplier Portal",
    components: [InvoiceLineItemsComponent],
    visible: true,
  },
];

const SupplierPortalPlugin: FC<PropsWithChildren> = ({ children }) => {
  const app = useSheshaApplication();
  useEffect(() => {
    app.registerFormDesignerComponents(
      SUPPLIER_PORTAL_PLUGIN_NAME,
      supplierPortalDesignerComponents,
    );
  }, []);

  return <>{children}</>;
};

export interface IAppProviderProps {
  backendUrl: string;
}

export const AppProvider: FC<PropsWithChildren<IAppProviderProps>> = ({
  children,
  backendUrl,
}) => {
  const nextRouter = useNextRouter();

  return (
    <GlobalStateProvider>
      <ShaApplicationProvider
        backendUrl={backendUrl}
        router={nextRouter}
        noAuth={nextRouter.path?.includes("/no-auth")}
        applicationKey="public-portal"
        buildHttpRequestHeaders={buildSupplierHeaders}
      >
        <GlobalPublicPortalStyles />
        <PublicPortalApplicationPlugin>
          <SupplierPortalPlugin>
            <EnterpriseApplicationPlugin>
              <SupplierContextProvider>
                <StoredFilesProvider
                  baseUrl={backendUrl}
                  ownerId={""}
                  ownerType={""}
                >
                  {children}
                </StoredFilesProvider>
              </SupplierContextProvider>
            </EnterpriseApplicationPlugin>
          </SupplierPortalPlugin>
        </PublicPortalApplicationPlugin>
      </ShaApplicationProvider>
    </GlobalStateProvider>
  );
};
